import AttachmentsViewerImageBase from "components/attachments/viewer/image/image.client.base"
import { Component } from "vue-property-decorator"

@Component
export default class AttachmentsViewerImageWeb extends AttachmentsViewerImageBase {}
